import { combineLoaders } from '@/lib/loader/combine-loader';
import { permissionsLoader } from '@/lib/loader/permission-loader';
import { lazy } from 'react';
import { FeatureFlagKey } from '@/features/feature-flag/feature-flag.constants';
import { withFeature } from '@/features/feature-flag/components/with-feature';

const TodayPage = lazy(() => import('./pages'));

export const todayRoute = [
  {
    path: '/today',
    // Login lands here; a client with Today off is sent on to the planner.
    Component: withFeature(FeatureFlagKey.MODULE_TODAY, TodayPage),
    loader: combineLoaders(permissionsLoader),
  },
];
